import * as React from 'react'
import info from '../info.json'
import { Link } from 'gatsby'
import { GatsbyImage, StaticImage } from 'gatsby-plugin-image'
import ProductCard from './product-card'
import Footer from './footer'
import { motion, animate } from 'framer-motion'

import {Swiper, SwiperSlide} from "swiper/react"
import {Pagination, EffectCoverflow, Mousewheel} from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/effect-coverflow'
import 'swiper/css/pagination'
import 'swiper/css/navigation'


export default function Slider(props){

    const [currentNumber, setCurrentNumber] = React.useState(1)
    const [productList, setProductList] = React.useState([...props.productsList])

    const [currentSlide, setCurrentSlide] = React.useState(1)
    const [totalSlides, setTotalSlides] = React.useState(0)

    console.log(productList);
    

    React.useEffect(()=>{
        var swiper = document.getElementsByClassName('swiper-wrapper')[0]

        setTotalSlides(swiper.childNodes.length)
        
    })

    function addSlide(swiper) {
        let r = swiper.realIndex, p = swiper.previousIndex
        let currentIndex = 1

        let previousSlideElement = swiper.slides[swiper.previousIndex]
        let currentSlideElement = swiper.slides[swiper.activeIndex]

        // currentSlideElement.childNodes[0].childNodes[2]
        let currentTitle = currentSlideElement.childNodes[0].getElementsByTagName('a')[0]
        let previousTitle = previousSlideElement.childNodes[0].getElementsByTagName('a')[0]
    
        if (previousTitle != undefined) {

            previousTitle.style.opacity = '0'

        }
        if (currentTitle != undefined) {
            currentTitle.style.opacity = '100'
        }
            if(r-p==1){
                setCurrentSlide(swiper.realIndex +1)

            }
            else if(p=1){
                setCurrentSlide(swiper.realIndex +1)

            }       
       
        

    }

    const productsImages = productList.filter((item)=>{
        
        return item.featuredImage == undefined ? false : true  
        
    }).sort((a, b) => {
        const aIsNew = a.flowerExtraFields?.isNew || false
        const bIsNew = b.flowerExtraFields?.isNew || false
        
        if (aIsNew && !bIsNew) return -1
        if (bIsNew && !aIsNew) return 1
        
        const aColor = a.flowerExtraFields?.color?.toLowerCase() || ''
        const bColor = b.flowerExtraFields?.color?.toLowerCase() || ''
        
        if (aColor === 'red' && bColor !== 'red') return -1
        if (bColor === 'red' && aColor !== 'red') return 1
        
        return a.title.localeCompare(b.title)
    })

    const products = productsImages.map((product, index)=>{

        let mainCategory = "";
        
        product.categories.nodes.forEach((cat) => {
            if (cat.name === "Spray Roses") {
              mainCategory = "Spray Rose";
            }
            if (cat.name === "Roses") {
              mainCategory = "Rose";
            }
          });

        const altText = `Premium Ecuadorian ${product.title} ${product.flowerExtraFields.color} ${mainCategory} fresh cut for wholesale export by Royal Flowers`
        
        if(product.featuredImage != undefined){
            
            return(
                <SwiperSlide className='flex w-fit md:min-w-[300px] '>
                    <ProductCard image={product.featuredImage.node.gatsbyImage} alt={altText} title={product.title} slug={product.slug} index={index} size={15} isNew={product.flowerExtraFields.isNew}/>
                </SwiperSlide>
    
            )

        }else{
            return
        }

        
    })
    
    
    const isLooping = products.length < 7 ? false : true 

    return(
        <motion.div 
            animate={{ opacity: 1, transform: 'translateY(0%)', transition: { duration: 0.8, delay: 0.5, type: 'spring'} }} 
            initial={{ opacity: 0, transform: 'translateY(3%)', }}
            className='swiper-container h-full w-full relative flex justify-center z-0'
        >
            <Swiper
                spaceBetween={10}
                loop={isLooping}
                slidesPerView={6}
                direction='horizontal'
                loopedSlides={3}
                mousewheel={
                    {
                        enabled: true,
                        sensitivity: 1,
                        releaseOnEdges: true
                    }
                }
                centeredSlides={false}
                grabCursor={true}

                pagination={
                    {
                        el: '.swiper-pagination', 
                        clickable:true,
                        renderBullet: function(index, className) {
                            return `<span class="${className}"></span>`
                            
                        }
                    }
                }
                initialSlide={props.isHome ? 1 : 0}

                breakpoints ={
                   { 
                        1500: {
                            slidesPerView: 6,
                            spaceBetween: 10,
                            centeredSlides: props.isHome ? true : false

                        },

                        1100: {
                            slidesPerView: 5,
                            spaceBetween: 10,
                            centeredSlides: props.isHome ? true : false

                        },
                        840: {
                            slidesPerView: 4,
                            spaceBetween: 10,
                            centeredSlides: props.isHome ? true : false

                        },
                        615: {
                            slidesPerView: 2,
                            spaceBetween: 10,
                            // centeredSlides: isLooping ? false :true
                        },
                        400: {
                            slidesPerView: 2,
                            spaceBetween: 10,
                            centeredSlides: true
                        },
                       
                        100: {
                            slidesPerView: 2,
                            centeredSlides: true

                        }
                        
                    }
                }

                modules={[EffectCoverflow, Pagination, Mousewheel]}
                onSlideChange={(swiper) => addSlide(swiper)}
                id='swiper-category'
                className='w-[100vw]'
                >
                    
                {products}


                {/* SE UTILIZA PARA PODER SCROLLEAR EN EL CASO QUE TENGA 6 Y LA PANTALLA LO ESTÉ CORTANDO */}
               {!isLooping && <SwiperSlide className='flex w-fit md:min-w-[300px]'>
                    <div></div>
                </SwiperSlide>}

            </Swiper>

            <Footer collection={props.collection} boolInfo={props.boolInfo} setVisibleInfo={props.setVisibleInfo} setVisible={props.setVisible} sliderLength={isLooping ? totalSlides : (totalSlides-1)} currentSlide={currentSlide} catalog={props.catalog}/>

        </motion.div>

    )

}